module.exports = require('./helpers/bundle-url').getBundleURL('ajLJU') + "logo.c51670a8.svg";